import React from 'react';

import {observer} from 'mobx-react';
import {AppModuleProps} from "../models/app-module.props";
import {RouteModel} from "../../components/router/models/route-model";
import {WidgetSponsorshipWrapper} from "../../components/misc/widget-sponsorship-wrapper";
import {IntersectionObserver, IntersectionObserverProps} from "../../components/intersection-observer/intersection-observer";
import {ManualScrollerWrapper} from "../../components/manual-scroll-wrapper/manual-scroll-wrapper";
import classNames from "classnames";
import styles from "../styles/app-module.module.scss"
import {AppModuleContentWidgetsStandAlone} from "./app-module.content-widgets.stand-alone";

export class AppModuleContentWidgetsComponentProps extends AppModuleProps {
  initialLinkModel: RouteModel;
}

export const AppModuleContentWidgets = observer(({
                                                   controller,
                                                   onWidgetVisible
                                                 }: AppModuleContentWidgetsComponentProps) => {
  const {state, domUtils, device} = controller;
  const {
    sponsoredBookmaker,
    settings,
    currentLinkModel,
    showDisclaimer,
    shouldRenderSponsorship,
    shouldRenderBottomPoweredBy,
    shouldRenderSponsorshipPoweredBy,
    poweredByModel,
    sponsorshipUrl,
    shouldRenderSponsorshipWrapper,
    shouldWidgetOverflow,
    dataInitialized,
    // initialRouteModel,
    // initialLinkModel,
    containerLimitHeight
  } = state;

  const {bootstrapSettings, useScrollingButtons} = settings;
  const {isSmallView, screenWidth} = device;

  sponsoredBookmaker?.id && bootstrapSettings.showSponsorship && domUtils.addBodyClass('sponsorship');

  const widgetSponsorshipWrapperProps = {
    showDisclaimer,
    shouldRenderSponsorship,
    shouldRenderBottomPoweredBy,
    shouldRenderSponsorshipPoweredBy,
    bookmaker: sponsoredBookmaker,
    currentLinkModelName: currentLinkModel?.name,
    poweredByText: poweredByModel.text,
    poweredByLink: poweredByModel.link,
    screenResolution: screenWidth,
    controller,
    i18n: state.terms,
    sponsorshipUrl
  }

  const intersectionObserver: IntersectionObserverProps = {
    onIntersect: onWidgetVisible,
    keepObserving: false,
    forceRender: true,
    className: classNames(styles.container, {[styles.overflow_container]: shouldWidgetOverflow}),
    style: {
      height: containerLimitHeight,
      maxHeight: containerLimitHeight,
      // overflowY: shouldWidgetOverflow ? 'auto' : 'hidden',
      // overflowX: 'hidden'
    }
  }

  const manualWrapperScroll = {
    isSmallView,
    shouldRenderSponsorshipWrapper
  }

  const handleRouterLoaded = () => {
    const element = document.getElementById(`widgets-loader_${controller.appSettings.bootstrapSettings.widgetId}`);
    if (element) {
      element.style.display = 'none';
    }
    const elementsPoweredBy = document.querySelectorAll("#powered-by");
    elementsPoweredBy?.forEach((element) => {
      element.style.display = 'flex'
    });
  }

  // const memoryRouterProps = {
  //   controller,
  //   initialLinkModel,
  //   initialRouteModel,
  //   showBackStripe: state.showBackStripe,
  //   handleRouterLoaded
  // }

  const standAloneProps = {
    controller,
    handleRouterLoaded,
    onWidgetVisible
  }

  if (!dataInitialized) {
    return <div/>;
  }

  return (
    <IntersectionObserver {...intersectionObserver}>
      <WidgetSponsorshipWrapper {...widgetSponsorshipWrapperProps}>
        {
          useScrollingButtons ? <ManualScrollerWrapper {...manualWrapperScroll}>
            <AppModuleContentWidgetsStandAlone {...standAloneProps}/>
          </ManualScrollerWrapper> : <AppModuleContentWidgetsStandAlone {...standAloneProps}/>
        }
      </WidgetSponsorshipWrapper>
    </IntersectionObserver>
  );
});
